import { css, styled } from "styled-components";
import { StyledText } from "styles/Text";
import { colors } from "constants/colors";
import { RadioType } from "types/Common";
import ImageButton from "./ImageButton";
import { useEffect, useRef } from "react";

type Props = {
  tabList: RadioType[];
  activeTabId: number;
  onClick: (value: any) => void;
  onLoad: () => void;
  isButton?: boolean;
  onButtonClick?: () => void;
  scrollToIndex?: number;
};

export default function HeaderTab({
  tabList,
  activeTabId,
  onClick,
  onLoad,
  isButton,
  onButtonClick,
  scrollToIndex,
}: Props) {
  const tabRefs = useRef<(HTMLLIElement | null)[]>([]);

  useEffect(() => {
    if (typeof scrollToIndex === "number") {
      const target = tabRefs.current[scrollToIndex];
      if (target) {
        target.scrollIntoView({
          inline: "center",
          behavior: "auto",
          block: "nearest",
        });
      }
    }
  }, [scrollToIndex]);

  return (
    <StyledTabBox onLoad={onLoad}>
      <StyledTabScroll>
        <StyledTab>
          {tabList.map((item, i) => {
            const selected = activeTabId === item.id;
            return (
              <StyledTabItem
                key={"subTabMenu" + item.id}
                selected={selected}
                ref={(el) => (tabRefs.current[i] = el)}
              >
                <StyledButton onClick={() => onClick(item.id)}>
                  <StyledText.Headline15
                    color={selected ? colors.black : colors.gray}
                  >
                    {item.label}
                  </StyledText.Headline15>
                </StyledButton>
              </StyledTabItem>
            );
          })}
        </StyledTab>
      </StyledTabScroll>
      {isButton && (
        <StyledGradientBox>
          <ImageButton
            width={36}
            height={36}
            source={require("assets/images/bt_open_n.png")}
            onClick={() => onButtonClick && onButtonClick()}
            backgroundStyle={{
              border: `1px solid ${colors.lightGray1}`,
              borderRadius: "8px",
              backgroundColor: colors.white,
            }}
          />
        </StyledGradientBox>
      )}
    </StyledTabBox>
  );
}

const StyledTabBox = styled.div`
  display: flex;
  height: 43px;
  width: 100%;
  align-items: center;
  background-color: ${colors.white};
  border-bottom: 1px solid ${colors.gray};
`;

const StyledTabScroll = styled.div`
  overflow-x: auto; /* 🔹 가로 스크롤 가능 */
  overflow-y: hidden;
  scrollbar-width: none; /* 🔹 파이어폭스용 스크롤바 숨김 */
  -ms-overflow-style: none; /* 🔹 IE/Edge용 스크롤바 숨김 */
  &::-webkit-scrollbar {
    display: none; /* 🔹 크롬/사파리용 스크롤바 숨김 */
  }
`;

const StyledTab = styled.ul`
  width: max-content;
  padding-left: 16px;
  padding-right: 16px;
`;

const StyledTabItem = styled.li<{ selected?: boolean }>`
  flex-shrink: 0; /* 🔹 줄바꿈 방지 */
  display: inline-block;
  padding: 10px 10px 8px 10px;
  border-bottom: 2px solid ${colors.white};

  ${({ selected }) =>
    selected &&
    css`
      border-color: ${colors.black};
    `};
`;

const StyledButton = styled.button`
  background: none;
  border: none;
  padding: 0;
`;

const StyledGradientBox = styled.div`
  display: flex;
  height: 100%;
  align-items: center;
  &:before {
    content: "";
    position: relative;
    z-index: 1;
    width: 16px;
    height: 100%;
    margin-left: -16px;
    background: linear-gradient(
      90deg,
      rgba(0, 0, 0, 0) 0%,
      rgb(255, 255, 255) 70%
    );
  }
  &:after {
    content: "";
    width: 16px;
    height: 100%;
    background-color: ${colors.white};
  }
`;
